<template lang="pug">
.d-contents
  div.slide-dialog(:class="{'slide-dialog--active': value}")
    div.slide-dialog__underlay(:class="{'slide-dialog__underlay--active': value}" )
    div.slide-dialog__container(:class="{'slide-dialog__container--active': value}")
      div.slide-dialog__header(@click="close")
        v-btn.slide-dialog__minimize-btn(color="primary")
          v-icon(left) mdi-chevron-down
          | Свернуть
      v-card.slide-dialog__content
        v-container.full-height(key="instruction" fluid).py-0
          v-row.full-height
            v-col.ui-select-menu.app-card.d-none.d-md-block.full-height.overflow-x-auto.grey.lighten-4(
              cols="12"
              :md="instructionId ? 4 : 12"
            )
              d-search-list(
                ref="list"
                :key="+value"
                v-model="instructions"
                :method="getInstructions"
                :search-props="searchProps"
                :filter-props="filterProps"
                v-slot="{ refresh }"
              )
                v-list(color="transparent")
                  v-list-item-group(v-model="instructionId")
                    v-list-item.pl-2(
                      v-for="instruction in instructions"
                      :key="instruction.id"
                      :value="instruction.id"
                      :class="{'ui-primary white--text' : instructionId === instruction.id}"
                    )
                      v-list-item-action.mr-2
                        v-icon(:color="instructionId === instruction.id ? 'white' : ''")
                          | {{ instruction.type === 1  ? 'mdi-video-outline' : 'mdi-text-box-outline' }}
                      v-list-item-title.text-wrap {{ instruction.name }}
            v-col.fill-height.overflow-x-auto(cols="12" md="8" v-if="instructionId")
              server-data(
                :key="instructionId"
                :method="() => $rApi.directories.showInctructionCached({ args: [instructionId] })"
                start-loading-value
                v-slot="{ loading, serverData: instruction }"
              )
                .d-flex.justify-center(v-if="loading")
                  v-progress-circular(indeterminate)
                .app-card(v-else-if="!instruction")
                  h3.ui-text--error Не удалось загрузить инструкцию
                .app-card(v-else)
                  .d-flex.align-center.justify-space-between.mb-2
                    h2 {{ instruction.name }}
                    HtmlTOPdf(
                      v-if="instruction.content && instruction.type === 2"
                      :fileName="instruction.name"
                    )
                      div.instruction(v-html="instruction.content")
                      template(#activator="{ generate, loading }")
                        v-tooltip(bottom)
                          template(v-slot:activator='{ on }')
                            v-btn(
                              fab
                              small
                              color="primary"
                              :loading="loading"
                              v-on='on'
                              @click="generate"
                            )
                              v-icon mdi-upload
                          span Скачать PDF

                  presentation-video(
                    v-if="value && instruction.type === 1 && Object.keys(instruction).length"
                    :src="instruction.url"
                    :min-height="450"
                    video-width="100%"
                    :stop="true"
                  )
                  div.instruction(ref="a" v-html="instruction.content" v-if="instruction.type === 2")
        slot(name="content" v-bind="{ hasInstructions }")
  slot(v-bind="{ hasInstructions }")
</template>

<script>
import PresentationVideo from '@/modules/Events/components/PresentationVideo.vue';
import { mapGetters } from 'vuex';
import VueHtml2pdf from 'vue-html2pdf';
import HtmlTOPdf from '@/components/HtmlTOPdf.vue';
import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';
import DSearchList from '@/packages/ui/components/DSearchList/DSearchList.vue';

export default {
  name: 'SlideDialog',
  components: {
    PresentationVideo,
    VueHtml2pdf,
    HtmlTOPdf,
    DvTextField,
    DSearchList,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      instructionId: undefined,

      instructions: [],

      searchProps: {
        attrs: {
          search: {
            filter: 'search[name]',
            attrs: {
              placeholder: 'Название инструкции',
              height: 44,
            },
          },
        },
      },

      opt: {
        margin: [1, 1, 1, 1],
        // filename: 'hee hee',
        // margin: 10,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 1, useCORS: true },
        // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      userRoles: 'auth/getUserRoles',
      isAuthenticated: 'auth/isAuthenticated',
    }),
    filterProps() {
      const { path } = this?.$route || {};
      const currentPath = path.replace(/\d+/g, '*');
      return {
        tabs: [
          {
            text: 'Инструкции по разделу',
            query: {
              'search[manual_filter]': currentPath,
            },
          },
          {
            text: 'Все инструкции',
            query: {
              'search[manual_filter]': undefined,
            },
          },
        ],
      };
    },
    hasInstructions() {
      return !!this.instructions.length;
    },
  },
  watch: {
    value: {
      handler(v) {
        if (!v) {
          this.instructionId = undefined;
        }
        document.documentElement.style.overflow = v ? 'hidden' : '';
      },
    },
    $route: {
      handler() {
        this.$nextTick(() => {
          this.refresh();
        });
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },

    async getInstructions({ params }) {
      if (!params.page) {
        this.instructions = [];
      }
      const { response, error } = await this.$rApi.directories.getInctructionsCached({
        params: {
          'search[system_id]': this.$conf.isVcht ? 5 : 2,
          'search[role_name]': this.isAuthenticated
            ? this.userRoles.join(',')
            : 'guest',
          fields: 'id,name,type',
          ...params,
        },
      });
      const items = response?.data?.data || [];
      // console.log('params', params['search[manual_filter]'], this.instructions.length, items.length);
      // console.log(params.page, response?.data?.data.length, response, params);
      return {
        items,
        response: {
          ...response,
          ...items.length === Number(response?.headers?.['x-pagination-total-count']) ? {
            headers: {
              ...response?.headers,
              'x-pagination-page-count': '1',
              'x-pagination-per-page': items.length,
            },
          } : {},
        },
        error,
      };
    },

    generatePDF() {
      this.$refs.html2Pdf.generatePdf();
    },
    refresh() {
      this.$refs.list?.refresh?.();
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: translateY(100%);
  backdrop-filter: blur(2px);
  z-index: 15;
  transition: all 0.3s;

  &--active {
    transition: none;
    transform: translateY(0);
  }
}
.slide-dialog__underlay {
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  background-color: #000;
  opacity: 0;
  transform: translateY(0);
  transition: none;

  &--active {
    transition: all 0.3s;
    opacity: 0.3;
    transform: translateY(0);
  }
}

.slide-dialog__container {
  height: 80%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  transform: translateY(100%);
  transition: all 0.3s;
  transition-delay: 0.3s;

  &--active {
    transition-delay: unset;
    transform: translateY(0);
  }
}

.slide-dialog__header {
  padding-top: 20px;
  text-align: center;
}

.slide-dialog__content {
  overflow-y: auto;
  flex: 1;
}

.instruction {
  ::v-deep img {
    max-width: 100%;
    height: auto !important;
    object-fit: cover !important;
  }
}

.slide-dialog__minimize-btn.v-btn {
  border-bottom-right-radius: unset!important;;
  border-bottom-left-radius: unset!important;
  padding: 0 2rem;
  opacity: 1;
}
</style>
